import {Directive, InjectionToken, OnDestroy} from '@angular/core';
import {BehaviorSubject, of, Subject} from 'rxjs';
import {switchMap, takeUntil} from 'rxjs/operators';
import {ValidationService} from '../../services/validation.service';
import {ValidationContext} from '../../data/validation-context';

export const VALIDATION_CONTEXT_REFLECTION = new InjectionToken<ValidationContext>('VALIDATION_CONTEXT_REFLECTION');

export function validationContextReflectionProvider(): ValidationContext {
    return new ValidationContext('reflection');
}

@Directive({})
export abstract class ValidationNamedContextBaseDirective implements OnDestroy {
    protected readonly name$ = new BehaviorSubject<string>(undefined);
    protected readonly us$ = new Subject<void>();

    protected constructor(
        protected readonly validationContextReflection: ValidationContext,
        protected readonly validationService: ValidationService,
    ) {
        this.name$
            .pipe(
                switchMap(($name: string) => {
                    if ($name !== undefined) {
                        return this.validationService.getContext$($name);
                    }
                    return of(undefined);
                }),
                switchMap(($context: ValidationContext) => {
                    if ($context) {
                        return $context.getFields$();
                    }
                    return of({});
                }),
                takeUntil(this.us$)
            )
            .subscribe($fields => {
                this.validationContextReflection.swapFields($fields);
            });
    }

    public ngOnDestroy(): void {
        this.name$.complete();

        this.us$.next();
        this.us$.complete();

        this.validationContextReflection.doDestroy(false);
    }
}

